<template>
  <div class="labeled-vehicle-make-list">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <VehicleMakeList
      ref="vehicleMakeList"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :empty-text="emptyText"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </VehicleMakeList>
  </div>
</template>

<script>
import { default as VehicleMakeList } from '../vehicle-make-list';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    label: {
      type: String,
      default: 'Оберіть марку транспортного засобу зі списку',
    },
    placeholder: {
      type: String,
      default: 'Виберіть марку транспортного засобу',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      inputId: `vehicle-make-list-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, VehicleMakeList },
  computed: {
    getVehicleMakeListSelect() {
      return this.$refs.vehicleMakeList;
    }
  },
  methods: {
    generateRandomId,
  },
};
</script>
